export enum FocalPointAnchors {
  TOP_LEFT = 'Top Left',
  TOP_CENTER = 'Top Center',
  TOP_RIGHT = 'Top Right',
  CENTER_LEFT = 'Center Left',
  CENTER = 'Center',
  CENTER_RIGHT ='Center Right',
  BOTTOM_LEFT ='Bottom Left',
  BOTTOM_CENTER = 'Bottom Center',
  BOTTOM_RIGHT = 'Bottom Right'
}

export enum ImageFittings {
  NONE = 'None',
  SCALE_TO_FIT = 'Scale to Fit',
  SCALE = 'Scale'
}
